import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import {
  notifyEcommerceSaved,
  setEcommerceSaveToastListener,
  type EcommerceSaveToastSeverity,
} from '../utils/ecommerceSaveToast';

interface ToastState {
  open: boolean;
  message: string;
  severity: EcommerceSaveToastSeverity;
}

const EcommerceSaveToastHost: React.FC = () => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    setEcommerceSaveToastListener(({ message, severity = 'success' }) => {
      setToast({ open: true, message, severity });
    });
    return () => setEcommerceSaveToastListener(null);
  }, []);

  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={2500}
      onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 1 }}
    >
      <Alert
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        severity={toast.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export { notifyEcommerceSaved };
export default EcommerceSaveToastHost;
